export enum AnswerStateEnum {
  Empty = 0,
  Typing = 1,
  Sending = 2,
  Success = 3,
}
